// const UserKey = "Lavrock-User";

// export function getUser() {
// 	const user = window.sessionStorage.getItem(UserKey)
// 		? JSON.parse(window.sessionStorage.getItem(UserKey))
// 		: null;
// 	return user;
// }

// export function setUser(user) {
// 	window.sessionStorage.setItem(UserKey, user);
// }

// export function removeUser() {
// 	window.sessionStorage.removeItem(UserKey);
// }

const UserKey = 'Lavrock-User'

export function getUser() {
	// const user = window.localStorage.getItem(UserKey)
	// 	? JSON.parse(window.localStorage.getItem(UserKey))
	// 	: null;
	const cache_user = JSON.parse(localStorage.getItem(UserKey) || 'null')
	if (cache_user && Date.now() < cache_user.expires) {
		return cache_user.data
	} else {
		return null
	}
}

export function setUser(user) {
	const cache_user = {
		data: JSON.parse(user),
		expires: Date.now() + 60 * 1000 * 6 * 60
	}
	window.localStorage.setItem(UserKey, JSON.stringify(cache_user))
}

export function removeUser() {
	window.localStorage.removeItem(UserKey)
}
